@import '@hevoio/hevo-ui-toolkit/styles/variables';

.acceptanceBanner,
.failureBanner {
  display: flex;
  align-items: flex-start;
  gap: $spacer-8;
  width: 100%;
  padding: $spacer-10 $spacer-16;
  border-radius: $border-radius-6;
  font-size: $font-size-body;
  line-height: $line-height-body;
  color: $text-sub-600;
}

.acceptanceBanner {
  background-color: var(--surface-bg-alternate-color);
}

.failureBanner {
  background-color: var(--zora-state-error-lighter);
}

.howToAcceptLink {
  padding: 0;
  border: 0;
  background: none;
  color: $primary-base;
  font: inherit;
  text-decoration: underline;
  cursor: pointer;
}

.whyExplanation {
  margin: $spacer-6 0 0;
  max-width: 720px;
  color: $text-sub-600;
}

.bannerIcon {
  flex-shrink: 0;
}
